import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCurrencyPounds: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="currency-pounds, money"><path d="M5.75 20.25C10.688 20.25 8.8855 11.313 8.8855 8.39062C8.8855 5.82768 10.9912 3.75 13.5888 3.75C15.2194 3.75 16.6563 4.56883 17.5 5.8125" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 20.25H18.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M5.75 12.25H14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconCurrencyPounds;
